import React from 'react';

import { AUTH_USER_ROUTE } from '@/App/AppRoutes/constants';
import type { LayoutRouteBaseConfig } from '@/App/AppRoutes/types';
import { HomeLayout } from '@/components/layout/HomeLayout';

export const HomeLayoutRouteBase: LayoutRouteBaseConfig = {
  key: 'home-layout',
  element: <HomeLayout authUserRoute={AUTH_USER_ROUTE} />,
};
